import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NextSeo } from "next-seo";

import Header from "../components_web/Header";
import Footer from "../components_web/Footer";
import SideMenu from "../components_web/SideMenu";
import { Constants } from "../src/config";
import { getClass } from "../src/helpers/formatHelpers";

const About = () => {
  const { t } = useTranslation();
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);

  return (
    <div>
      <NextSeo
        title={`About`}
        description={process.env.NEXT_PUBLIC_APP_ABOUT}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/about`}
        additionalMetaTags={{
          name: "keywords",
          content:
            "about, festival, event, artist, music, live music, concert, ticket",
        }}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/about`,
          title: `About - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: process.env.NEXT_PUBLIC_APP_ABOUT,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      {/* About Section */}
      <div className={`${getClass("background5", true)}`} id="about">
        <div
          className={`wrapper mx-auto relative py-40 ${
            process.env.NEXT_PUBLIC_APP_NAME !== "Vybeful" &&
            process.env.NEXT_PUBLIC_APP_NAME !== "Festicket"
              ? "min-h-screen py-60 flex justify-center items-center"
              : ""
          }`}>
          <div className="flex flex-col items-center">
            <h1
              className={`sm:text-3xl text-lg font-bold ${getClass(
                "text-white",
                true
              )} text-center sm:mb-6 mb-3`}>
              {t("key_web_home_about_title")}
            </h1>
            <div
              className={`sm:text-xl text-base font-regular text-center ${getClass(
                "text-white80",
                true
              )} sm:mb-6 mb-3`}>
              {process.env.NEXT_PUBLIC_APP_ABOUT}
            </div>
            {process.env.NEXT_PUBLIC_APP_NAME != "Zoopedia" &&
              process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
              process.env.NEXT_PUBLIC_APP_NAME != "Parkful" &&
              process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
              process.env.NEXT_PUBLIC_APP_NAME != "Castlepedia" &&
              process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
              process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub" && (
                <div
                  className={`sm:text-xl text-base font-regular text-center ${getClass(
                    "text-white80",
                    true
                  )} sm:mb-6 mb-10`}>
                  {t("key_web_home_about_text_2")}
                </div>
              )}
            {process.env.NEXT_PUBLIC_APP_NAME === "Festicket" && (
              <div
                className={`sm:text-xl text-base font-regular text-center ${getClass(
                  "text-white80",
                  true
                )} sm:mb-6 mb-10`}>
                Festicket is an active, independent platform launched in 2026
                providing information about music festivals. We have no affiliation with
                either of the previous businesses that operated under the
                Festicket name: Festicket Ltd or Festicket operated by Lyte.
              </div>
            )}
            {/* {process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
              process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
              process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
              process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub" && (
                <div
                  className={`sm:text-xl text-base font-regular text-center ${getClass(
                    "text-white80",
                    true
                  )} sm:mb-6 mb-10`}>
                  Discover also our sister platforms:
                </div>
              )} */}
            {/* {process.env.NEXT_PUBLIC_APP_NAME != "Zoopedia" &&
              process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
              process.env.NEXT_PUBLIC_APP_NAME != "Parkful" &&
              process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
              process.env.NEXT_PUBLIC_APP_NAME != "Castlepedia" &&
              process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
              process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub" && (
                <>
                  {Constants.websiteList?.map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      className={`sm:text-xl text-base font-bold text-center ${getClass(
                        "text-white",
                        true
                      )} sm:mb-6 mb-10 uppercase`}>
                      {item.label?.replace(" ", "")}
                    </a>
                  ))}
                </>
              )} */}
            {/* {(process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
              process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
              process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia") && (
              <>
                {Constants.websiteList2?.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className={`sm:text-xl text-base font-bold text-center ${getClass(
                      "text-white",
                      true
                    )} sm:mb-6 mb-10 uppercase`}>
                    {item.label?.replace(" ", "")}
                  </a>
                ))}
              </>
            )} */}
            {/* {(process.env.NEXT_PUBLIC_APP_NAME === "Vybeful" ||
              process.env.NEXT_PUBLIC_APP_NAME === "Festicket") && (
              <img
                src="/images/Images-circle.png"
                width="650"
                alt="about"
                className="sm:mt-10 mt-6"
              />
            )} */}
          </div>
        </div>
      </div>

      {/* Slogan section */}
      {(process.env.NEXT_PUBLIC_APP_NAME === "Vybeful" ||
        process.env.NEXT_PUBLIC_APP_NAME === "Festicket") && (
        <div
          className="w-full md:h-800px h-300px"
          style={{
            backgroundImage: "url(/images/slogan_bg.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}></div>
      )}

      <Footer />
    </div>
  );
};

export default About;
